/**
 * @file 無料登録
 *
 */
'use strict';
import Common from '../../Utils/Common';

/**
 * @classname RadioGroup
 * @classdesc お届け先変更
 */
export default class RadioGroup {
	/**
	 * @constructor
	 * @param {jQuery} $e - .radio-group
	 */
	constructor($e) {
		console.log('RadioGroup.constructor');
		this._$e = $e;
		this._$radio = $e.find('> .input-radio .input-radio__input');
		const target = $e.attr('data-target');
		const target2 = $e.attr('data-target2');
		const target3 = $e.attr('data-target3');
		this._$target = $(target);
		this._$target2 = $(target2);
		this._$target3 = $(target3);
		this._id = $e.attr('data-show-id');
		this._id2 = $e.attr('data-show-id2');
		this._id3 = $e.attr('data-show-id3');
		this._$radio.on('click', (e) => this.onClick(e));
		this.checkInitialStatus();
	};


	/**
	 * clickのコールバック
	 *
	 * @memberof RadioGroup
	 * @return {undefined}
	 */
	checkInitialStatus() {
		console.log('RadioGroup.checkInitialStatus');
		const $checked = this._$e.find('> .input-radio > .input-radio__input:checked');
		const id = $checked.attr('id');
		console.log(`${id} / ${this._id}`);
		if(id === this._id){
			console.log(`${this._$radio.attr('name')}:${this._id}`);
			Common.showFormWrap(this._$target, false);
			Common.hideFormWrap(this._$target2, false);
			Common.hideFormWrap(this._$target3, false);
		}else if(id === this._id2){
			console.log(`${this._$radio.attr('name')}:${this._id2}`);
			Common.showFormWrap(this._$target2, false);
			Common.hideFormWrap(this._$target, false);
			Common.hideFormWrap(this._$target3, false);
		}else if(id === this._id3){
			console.log(`${this._$radio.attr('name')}:${this._id3}`);
			Common.showFormWrap(this._$target3, false);
			Common.hideFormWrap(this._$target, false);
			Common.hideFormWrap(this._$target2, false);
		}else{
			console.log(`${this._$radio.attr('name')}:no match`);
			Common.hideFormWrap(this._$target, false);
			Common.hideFormWrap(this._$target2, false);
			Common.hideFormWrap(this._$target3, false);
		}
		this._$radio.each((idx,e) => {
			const $e = $(e);
			if($e.prop('checked')){
				$e.click();
			}
		});
		// 別の住所に送る
		if($checked.hasClass('another_address') && this._$e.data('target').match(/#delivery_address./)){
			const $registerAddressWrap = $('.register-address-wrap');
			if($('.is_with_register_receiver_address').prop('checked')){
				console.log('show address register');
				Common.showFormWrap($registerAddressWrap);
			}else{
				console.log('hide address register');
				Common.hideFormWrap($registerAddressWrap);
			}
		}
		// ギフト設定
		if($checked.hasClass('set-gift') && this._$e.data('target').match(/#gift-wrap./)) {
			const $celebrationMessageWrap = $('.celebration_message_wrap');
			if($('.celebration_message').prop('checked')){
				console.log('show gift');
				Common.showFormWrap($celebrationMessageWrap);
			}else{
				console.log('hide gift');
				Common.hideFormWrap($celebrationMessageWrap);
			}
		}
	};

	/**
	 * clickのコールバック
	 *
	 * @memberof RadioGroup
	 * @param {event} e - クリックイベント
	 * @return {undefined}
	 */
	onClick(e) {
		console.log('RadioGroup.onClick');
		const $e = $(e.currentTarget);
		console.log($e);
		console.log(this._$target);
		if($e.attr('id') === this._id) {
			Common.showFormWrap(this._$target);
			Common.hideFormWrap(this._$target2);
			Common.hideFormWrap(this._$target3);
		}else if ($e.attr('id') === this._id2) {
			Common.showFormWrap(this._$target2);
			Common.hideFormWrap(this._$target);
			Common.hideFormWrap(this._$target3);
		}else if ($e.attr('id') === this._id3) {
			Common.showFormWrap(this._$target3);
			Common.hideFormWrap(this._$target2);
			Common.hideFormWrap(this._$target);
		}else{
			Common.hideFormWrap(this._$target);
			Common.hideFormWrap(this._$target2);
			Common.hideFormWrap(this._$target3);
		}
		// 別の住所に送る
		if($e.hasClass('another_address') && this._$e.data('target').match(/#delivery_address./)){
			const $registerAddressWrap = $('.register-address-wrap');
			if($('.is_with_register_receiver_address').prop('checked')){
				Common.showFormWrap($registerAddressWrap);
			}else{
				Common.hideFormWrap($registerAddressWrap);
			}
		}
		// ギフト設定
		if($e.hasClass('set-gift') && this._$e.data('target').match(/#gift-wrap./)) {
			const $celebrationMessageWrap = $('.celebration_message_wrap');
			if($('.celebration_message').prop('checked')){
				console.log('show gift');
				Common.showFormWrap($celebrationMessageWrap);
			}else{
				console.log('hide gift');
				Common.hideFormWrap($celebrationMessageWrap);
			}
		}
		// お届け日
		if($e.hasClass('specify') && this._$e.data('target').match(/#hope_delivery_date./)) {
			let selected = false;
			this._$e.find('select option').each((idx, e) => {
				const $option = $(e);
				if($option.prop('selected')) {
					selected = true;
					console.log(selected);
				}
			})
			console.log(selected);
			if(!selected) {
				console.log('select first option');
				this._$e.find('select option:first-child').prop('selected', true);
			}
		}
	};
}
